import { ComputedRef } from 'vue'

import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { JudgeStateViewModel } from '@/presentation/viewmodels/judge/judgeStateViewModel'

export class JudgeStatePresenter {
  private viewModel: JudgeStateViewModel

  constructor(viewModel: JudgeStateViewModel) {
    this.viewModel = viewModel
  }

  get judgeId(): ComputedRef<string> {
    return this.viewModel.judgeId
  }

  get isTestLoading(): ComputedRef<boolean> {
    return this.viewModel.isTestLoading
  }

  get isJudgeLoading(): ComputedRef<boolean> {
    return this.viewModel.isJudgeLoading
  }

  get isTestNotificationLoading(): ComputedRef<boolean> {
    return this.viewModel.isTestNotificationLoading
  }

  get isJudgeNotificationLoading(): ComputedRef<boolean> {
    return this.viewModel.isJudgeNotificationLoading
  }

  get judgeRecord(): ComputedRef<JudgeRecord | null> {
    return this.viewModel.judgeRecord
  }

  get testInput(): ComputedRef<string> {
    return this.viewModel.testInput
  }

  get testOutput(): ComputedRef<string> {
    return this.viewModel.testOutput
  }

  setTestInput(testInput: string): void {
    this.viewModel.setTestInput(testInput)
  }

  setTestOutput(testOutput: string): void {
    this.viewModel.setTestOutput(testOutput)
  }
}
